import React from 'react';

import { Container } from './styles';

const News: React.FC = () => {
  return (
    <Container>
      <span>Assuntos do momento no Brasil</span>
      <strong>Aprenda a manusear o seu machado com Kratos o good of war</strong>
    </Container>
  );
}

export default News;